import { render, staticRenderFns } from "./FakturPajakUserAccessEdit.vue?vue&type=template&id=0f10e8bf&scoped=true"
import script from "./FakturPajakUserAccessEdit.vue?vue&type=script&lang=js"
export * from "./FakturPajakUserAccessEdit.vue?vue&type=script&lang=js"
import style0 from "./FakturPajakUserAccessEdit.vue?vue&type=style&index=0&id=0f10e8bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10e8bf",
  null
  
)

export default component.exports